import { type FieldConfig, useField } from 'formik';

import { isDefined } from '@yoweb/utils/isDefined';
import SelectUI, { type SelectUIProps } from './SelectUI';

export type SelectProps = SelectUIProps &
  FieldConfig & { onChangeCallback?(value: unknown): void } & DataTestId;

/**
 * An Formik controlled Select component.
 */
function Select({ onChangeCallback, ...props }: SelectProps) {
  const [field, meta, actions] = useField(props);

  const onChange = (value: unknown) => onChangeCallback?.(value);

  const error = isDefined(props.error) ? props.error : meta.error;

  return (
    <SelectUI
      {...field}
      {...props}
      {...actions}
      onChangeCallback={onChange}
      error={meta.touched ? error : undefined}
    />
  );
}

export default Select;
